
import Vue from "vue";
import RULES from "@/mixins/rules";
import { mapGetters } from "vuex";
import RequestFormGral from "../RequestFormGral.vue";
import LicenciaService from "@/services/LicenciaService";

export default Vue.extend({
  name: "UpdateEstablishment",
  props: {
      idSolicitud: String,
      value: Object,
    },
  mixins: [RULES],
  components: { RequestFormGral },
  directives: {},
  computed: {
    ...mapGetters({
      usuario: "usuario",
      id: "id",
      contribuyente: "contribuyente",
      mini: "sidebar",
    }),
  },
  data: () => ({
    tipo_proceso: "0",
    establecimiento: "0",
    guardar: false,
    actualizar: false,
    enviado_revision: false,
    creado: false,
    id_creado: 0,
    disabled: false,
    canSubirLicencia: false,
    licenciaId: 0,
    disabledEnviar: false,
    estatusUsoSuelo: 0,
    anio_corriente: false,
    anio_ultima_licencia: 0
  }),
  mounted() {
      console.log("mounted index", this.idSolicitud);
      this.establecimiento = this.idSolicitud;
  },
  methods: {
    async submitForm(payload: any){
      this.guardar = false;
      this.actualizar = false;
      //console.log("submitform update", payload);
      if (payload.success) {
        this.creado = true;
        this.id_creado = payload.location.id;
         
        //ordenar licencia el ultimo año trabajado va primero
        let licenciasOrdenadas = payload.location.licencia.sort((a: any, b: any) => {
          return b.anio - a.anio;
        });
        console.log("licenciasOrdenadas", licenciasOrdenadas);
        if(licenciasOrdenadas.length){
          

          if (licenciasOrdenadas[0].anio == new Date().getFullYear() && licenciasOrdenadas.length > 1) {
            this.anio_corriente = true;
          }
          this.anio_ultima_licencia = licenciasOrdenadas[0].anio;

          console.log("anio_ultima_licencia", this.anio_ultima_licencia);

          this.disabledEnviar = false;
          this.licenciaId = licenciasOrdenadas[0].id;
          //console.log("constancia_uso_suelo", payload.location?.constancia_uso_suelo);
          if (licenciasOrdenadas[0].estatus_licencia == 10 || licenciasOrdenadas[0].estatus_licencia == 3 || licenciasOrdenadas[0].estatus_licencia == 4) {
            this.enviado_revision = true;
            this.disabled = true;
          }
          if (payload.location?.constancia_uso_suelo[0]?.estatus_general){
            this.estatusUsoSuelo = payload.location?.constancia_uso_suelo[0]?.estatus_general;
            if (this.estatusUsoSuelo == 5) {
              this.disabled = false;
            }
          }
          //console.log("estatusUsoSuelo", this.estatusUsoSuelo);
        }else{
          this.disabledEnviar = true;
        }
        this.canSubirLicenciaBebidas(payload);
      }
      //console.log("estatusUsoSuelo", this.estatusUsoSuelo);
    },
    async enviarRevision(){
      const object = {
        'estatus_licencia': 10,
      }
      //@ts-ignore
      this.$refs.requestFormGral.handleForValidate().then(async (response) => {
        if (response) {
            //@ts-ignore
            this.$refs.requestFormGral.handleFormSubmit();
            //Check if renovacion is 1 or true send to new service enviarRevision on RenovacionController
            let { data } = await LicenciaService.changeEstatus(this.licenciaId, object);
            if (data.success) {
              this.enviado_revision = true;
              this.disabled = true;
              this.$toast.success(data.message);
            } else {
              this.$toast.error(data.message)
            }
        }
      })
    },
    async enviarRevisionUsoSuelo(){
      const object = {
        'estatus_general': 1,
      }
      //@ts-ignore
      this.$refs.requestFormGral.handleFormSubmit();
      //Check if renovacion is 1 or true send to new service enviarRevision on RenovacionController
      let { data } = await LicenciaService.changeEstatusUsoSuelo(this.licenciaId, object);
      if (data.success) {
        this.estatusUsoSuelo = 1;
        this.$toast.success(data.message);
      } else {
        this.$toast.error(data.message)
      }
    },
    canSubirLicenciaBebidas(payload: any) {
      const pago = payload.location.archivos.find((archivo: any) => archivo.archivo.tipo_archivo == "pago_licencia_bebidas");
      if (!pago) {
        this.canSubirLicencia = false;
      }else{
        let date = new Date(pago.archivo.created_at);
        date.setMonth(date.getMonth() + 2);
        let fechaActual = new Date();
        if (date >= fechaActual) {
          this.canSubirLicencia = false;
        } else {
          this.canSubirLicencia = true;
        }
      }
      
      console.log('canSubirLicenciaBebidas', pago);
      console.log('canSubirLicenciaBebidas', this.canSubirLicencia);
      
    }
  }
});
